import { http } from "./http.js";

async function getWarehouseDetails() {
  const response = await http.get("warehouse-details");
  return response.data.length ? response.data.map(r => {
    return {
      id: r.Id,
      shipping: r.Shipping ? {
        id: r.Shipping.Id,
        number: r.Shipping.Number,
        clientAlias: r.Shipping.ClientAlias,
        client: r.Shipping.Client ? { id: r.Shipping.Client.Id, title: r.Shipping.Client.Title } : null,
        sender: r.Shipping.Sender,
      } : null,
      shippingPhaseFrom: r.ShippingPhaseFrom ? {
        id: r.ShippingPhaseFrom.Id,
        isCrossingUkrainianBorder: r.ShippingPhaseFrom.IsCrossingUkrainianBorder,
        isLast: r.ShippingPhaseFrom.IsLast,
        loadingDate: r.ShippingPhaseFrom.LoadingDate,
        unloadingDate: r.ShippingPhaseFrom.UnloadingDate,
        notes: r.ShippingPhaseFrom.Notes,
        readyForCombination: r.ShippingPhaseFrom.ReadyForCombination,
        transportTypes: r.ShippingPhaseFrom.TransportTypes,
        state: r.ShippingPhaseFrom.State ? {
          id: r.ShippingPhaseFrom.State.Id,
          title: r.ShippingPhaseFrom.State.Title,
        } : null,
        sendingPoint: {
          address: r.ShippingPhaseFrom.SendingPoint.Address ? {
            id: r.ShippingPhaseFrom.SendingPoint.Address.Id,
            title: r.ShippingPhaseFrom.SendingPoint.Address.Title,
            postcode: r.ShippingPhaseFrom.SendingPoint.Address.Postcode,
          } : null,
          factory: r.ShippingPhaseFrom.SendingPoint.Factory ? {
            id: r.ShippingPhaseFrom.SendingPoint.Factory.Id,
            title: r.ShippingPhaseFrom.SendingPoint.Factory.Title,
          } : null,
          warehouse: r.ShippingPhaseFrom.SendingPoint.Warehouse ? {
            id: r.ShippingPhaseFrom.SendingPoint.Warehouse.Id,
            title: r.ShippingPhaseFrom.SendingPoint.Warehouse.Title,
          } : null,
        },
        arrivalPoint: {
          address: r.ShippingPhaseFrom.ArrivalPoint.Address ? {
            id: r.ShippingPhaseFrom.ArrivalPoint.Address.Id,
            title: r.ShippingPhaseFrom.ArrivalPoint.Address.Title,
            postcode: r.ShippingPhaseFrom.ArrivalPoint.Address.Postcode,
          } : null,
          factory: r.ShippingPhaseFrom.ArrivalPoint.Factory ? {
            id: r.ShippingPhaseFrom.ArrivalPoint.Factory.Id,
            title: r.ShippingPhaseFrom.ArrivalPoint.Factory.Title,
          } : null,
          warehouse: r.ShippingPhaseFrom.ArrivalPoint.Warehouse ? {
            id: r.ShippingPhaseFrom.ArrivalPoint.Warehouse.Id,
            title: r.ShippingPhaseFrom.ArrivalPoint.Warehouse.Title,
          } : null,
        },
        counterparty: r.ShippingPhaseFrom.Counterparty ? {
          carrier: r.ShippingPhaseFrom.Counterparty.Carrier ? {
            id: r.ShippingPhaseFrom.Counterparty.Carrier.Id,
            title: r.ShippingPhaseFrom.Counterparty.Carrier.Title,
          } : null,
          client: r.ShippingPhaseFrom.Counterparty.Client ? {
            id: r.ShippingPhaseFrom.Counterparty.Client.Id,
            title: r.ShippingPhaseFrom.Counterparty.Client.Title,
          } : null,
          warehouse: r.ShippingPhaseFrom.Counterparty.Warehouse ? {
            id: r.ShippingPhaseFrom.Counterparty.Warehouse.Id,
            title: r.ShippingPhaseFrom.Counterparty.Warehouse.Title,
          } : null,
        } : null,
        route: r.ShippingPhaseFrom.Route ? {
          id: r.ShippingPhaseFrom.Route.Id,
          title: r.ShippingPhaseFrom.Route.Title,
        } : null,
        type: {
          id: r.ShippingPhaseFrom.Type.Id,
          title: r.ShippingPhaseFrom.Type.Title,
        },
      } : null,
      shippingPhaseTo: r.ShippingPhaseTo ? {
        id: r.ShippingPhaseTo.Id,
        isCrossingUkrainianBorder: r.ShippingPhaseTo.IsCrossingUkrainianBorder,
        isLast: r.ShippingPhaseTo.IsLast,
        loadingDate: r.ShippingPhaseTo.LoadingDate,
        unloadingDate: r.ShippingPhaseTo.UnloadingDate,
        notes: r.ShippingPhaseTo.Notes,
        readyForCombination: r.ShippingPhaseTo.ReadyForCombination,
        transportTypes: r.ShippingPhaseTo.TransportTypes,
        state: r.ShippingPhaseTo.State ? {
          id: r.ShippingPhaseTo.State.Id,
          title: r.ShippingPhaseTo.State.Title,
        } : null,
        sendingPoint: {
          address: r.ShippingPhaseTo.SendingPoint.Address ? {
            id: r.ShippingPhaseTo.SendingPoint.Address.Id,
            title: r.ShippingPhaseTo.SendingPoint.Address.Title,
            postcode: r.ShippingPhaseTo.SendingPoint.Address.Postcode,
          } : null,
          factory: r.ShippingPhaseTo.SendingPoint.Factory ? {
            id: r.ShippingPhaseTo.SendingPoint.Factory.Id,
            title: r.ShippingPhaseTo.SendingPoint.Factory.Title,
          } : null,
          warehouse: r.ShippingPhaseTo.SendingPoint.Warehouse ? {
            id: r.ShippingPhaseTo.SendingPoint.Warehouse.Id,
            title: r.ShippingPhaseTo.SendingPoint.Warehouse.Title,
          } : null,
        },
        arrivalPoint: {
          address: r.ShippingPhaseTo.ArrivalPoint.Address ? {
            id: r.ShippingPhaseTo.ArrivalPoint.Address.Id,
            title: r.ShippingPhaseTo.ArrivalPoint.Address.Title,
            postcode: r.ShippingPhaseTo.ArrivalPoint.Address.Postcode,
          } : null,
          factory: r.ShippingPhaseTo.ArrivalPoint.Factory ? {
            id: r.ShippingPhaseTo.ArrivalPoint.Factory.Id,
            title: r.ShippingPhaseTo.ArrivalPoint.Factory.Title,
          } : null,
          warehouse: r.ShippingPhaseTo.ArrivalPoint.Warehouse ? {
            id: r.ShippingPhaseTo.ArrivalPoint.Warehouse.Id,
            title: r.ShippingPhaseTo.ArrivalPoint.Warehouse.Title,
          } : null,
        },
        counterparty: r.ShippingPhaseTo.Counterparty ? {
          carrier: r.ShippingPhaseTo.Counterparty.Carrier ? {
            id: r.ShippingPhaseTo.Counterparty.Carrier.Id,
            title: r.ShippingPhaseTo.Counterparty.Carrier.Title,
          } : null,
          client: r.ShippingPhaseTo.Counterparty.Client ? {
            id: r.ShippingPhaseTo.Counterparty.Client.Id,
            title: r.ShippingPhaseTo.Counterparty.Client.Title,
          } : null,
          warehouse: r.ShippingPhaseTo.Counterparty.Warehouse ? {
            id: r.ShippingPhaseTo.Counterparty.Warehouse.Id,
            title: r.ShippingPhaseTo.Counterparty.Warehouse.Title,
          } : null,
        } : null,
        route: r.ShippingPhaseTo.Route ? {
          id: r.ShippingPhaseTo.Route.Id,
          title: r.ShippingPhaseTo.Route.Title,
        } : null,
        type: {
          id: r.ShippingPhaseTo.Type.Id,
          title: r.ShippingPhaseTo.Type.Title,
        },
      } : null,
      state: r.State,
      warehouseNumber: r.WarehouseNumber,
    };
  }) : [];
}

async function updateWarehouseNumber(id, value) {
  const response = await http.patch(`warehouse-details/${id}/warehouse-number`, { value });
  return response.data;
}

async function getTransitions(id) {
  const response = await http.get(`warehouse-details/${id}/transitions`);
  if (!response.data) {
    return null;
  }
  return {
    next: response.data.Next?.length ? response.data.Next.map(n => {
      return {
        id: n.Id,
        title: n.Title,
      };
    }) : [],
    prev: response.data.Prev ? {
      id: response.data.Prev.Id,
      title: response.data.Prev.Title,
    } : null,
  };
}

async function changeWarehousePhaseState(id, state) {
  const response = await http.patch(`warehouse-details/${id}/state`, { value: state });
  return response;
}

async function backToPrevWarehousePhaseState(id) {
  const response = await http.patch(`warehouse-details/${id}/back-to-prev-state`);
  return response;
}

export { getWarehouseDetails, updateWarehouseNumber, getTransitions, changeWarehousePhaseState, backToPrevWarehousePhaseState };